import { AnchorHTMLAttributes } from "react"
import { Link } from "react-router-dom"

export function ClientSurveyLink({ children, ...props }: AnchorHTMLAttributes<HTMLAnchorElement>) {
    return (
        <Link to={`/survey/psy`} {...props}>
            {children}
        </Link>
    )
}
